import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export function createAuthConfig(): AuthConfig {
  const cyncly = environment.oauth.cyncly;

  return {
    ...cyncly,
    responseType: 'code',
    oidc: true,
    requestAccessToken: true,
    useSilentRefresh: true,
    strictDiscoveryDocumentValidation: false,
    clearHashAfterLogin: true,
    requireHttps: true,
    customQueryParams: { domain_hint: 'promob.com' },
    showDebugInformation: !environment.production
  };
}
